import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { MembershipPageHeader } from 'memberships/components'
import { HomePortTypeSection } from '../components'
import { selectors } from 'memberships/reducer'
import { selectors as memberSelectors } from 'member-reducer'
import { MembershipType } from 'types'
import { PATH, makeMembershipIdPath } from 'config'

const propTypes = {
  membership: MembershipType,
}

function HomePortType({ membership }) {
  const { sfid: membershipId } = membership

  return (
    <>
      <MembershipPageHeader
        backLinkText="Back to Boat & Home Port Information"
        backLinkTo={makeMembershipIdPath(membershipId, PATH.BOATS)}
        membership={membership}
      />
      <HomePortTypeSection
        nextStep={makeMembershipIdPath(
          membershipId,
          PATH.BOATS,
          PATH.HOME_PORT_ADDRESS
        )}
      />
    </>
  )
}

HomePortType.propTypes = propTypes

function mapStateToProps(state) {
  return {
    account: selectors.account(state),
    membership: memberSelectors.membership(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  HomePortType
)
